export const defaultFormOption = {
    colGap: 0,
    rowGap: 0,
    span: 24,
    minWidth:70,
    marginTop:"2px",
    autoLabelWidth:true,
    scrollToFirstError:true,
    layout:'horizontal',
    gutter:10,
    labelAlign:"left",
    columns:[],
    justify:"start",
    align:"start",
    wrap:true,
    submitBtn:true,
    resetBtn:true,
    menuBtn:true,
    menu:true,
    submitBtnText:"submit",
    resetBtnText:"reset",
    size: "small",
    labelWidth:'240px',
  };
  export const imgPath='/aivon/static/images/country/'